export const Loader: React.FC<{
  height?: number;
  width?: number;
  color?: string;
  fullScreen?: boolean;
  halfScreen?: boolean;
}> = ({ height, width, color, fullScreen, halfScreen }) => {
  return (
    <div
      style={{
        height: halfScreen ? "100px" : "auto",
      }}
      className={`${
        fullScreen || halfScreen
          ? "flex flex-1 justify-center items-center"
          : ""
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 2400 2400"
        width={width || 24}
        height={height || 24}
      >
        <g
          strokeWidth="200"
          strokeLinecap="round"
          stroke={color || "#000000"}
          fill="none"
          id="spinner"
        >
          <line x1="1200" y1="600" x2="1200" y2="100" />
          <line opacity="0.5" x1="1200" y1="2300" x2="1200" y2="1800" />
          <line opacity="0.917" x1="900" y1="680.4" x2="650" y2="247.4" />
          <line opacity="0.417" x1="1750" y1="2152.6" x2="1500" y2="1719.6" />
          <line opacity="0.833" x1="680.4" y1="900" x2="247.4" y2="650" />
          <line opacity="0.333" x1="2152.6" y1="1750" x2="1719.6" y2="1500" />
          <line opacity="0.75" x1="600" y1="1200" x2="100" y2="1200" />
          <line opacity="0.25" x1="2300" y1="1200" x2="1800" y2="1200" />
          <line opacity="0.667" x1="680.4" y1="1500" x2="247.4" y2="1750" />
          <line opacity="0.167" x1="2152.6" y1="650" x2="1719.6" y2="900" />
          <line opacity="0.583" x1="900" y1="1719.6" x2="650" y2="2152.6" />
          <line opacity="0.083" x1="1750" y1="247.4" x2="1500" y2="680.4" />
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            keyTimes="0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667"
            values="0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199"
            dur="0.83333s"
            begin="0s"
            repeatCount="indefinite"
            calcMode="discrete"
          />
        </g>
      </svg>
    </div>
  );
};

interface DefaultSVgProps {
  height: number;
  width: number;
  color: string;
}

export const LandingSvg: React.FC<DefaultSVgProps> = ({
  height,
  width,
  color,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1357"
      height="815"
      viewBox="0 0 1357 815"
      fill="none"
    >
      <path
        d="M1356.5 385.13L1356.5 814.814L576.048 814.814L576.048 385.13C576.048 282.987 617.159 185.028 690.336 112.802C763.514 40.5762 862.764 0.000169204 966.253 0.000164186C1017.5 -0.00466008 1068.24 9.95341 1115.59 29.3058C1162.94 48.6582 1205.96 77.0258 1242.19 112.789C1278.43 148.552 1307.18 191.01 1326.79 237.739C1346.4 284.467 1356.5 334.551 1356.5 385.13Z"
        fill="#FAFAFA"
      />
      <path
        d="M0 814.814L-1.69327e-05 385.13C-2.09579e-05 282.987 41.1107 185.028 114.288 112.802C187.466 40.5762 286.716 0.000169204 390.205 0.000164186C493.694 0.000159168 592.944 40.5762 666.121 112.802C739.299 185.028 780.41 282.987 780.41 385.13L780.41 814.814L0 814.814Z"
        fill="#12243A"
      />
      <path
        d="M678.214 125.106C612.482 195.029 575.984 286.906 576.048 382.29L576.048 814.814L780.418 814.814L780.418 382.474C780.533 287.019 744.016 195.062 678.214 125.106Z"
        fill="#12243A"
      />
      <path
        d="M780.403 814.814L780.403 497.622C780.403 460.293 787.853 423.33 802.326 388.842C816.8 354.355 838.014 323.019 864.757 296.623C891.5 270.228 923.25 249.29 958.191 235.005C993.133 220.719 1030.58 213.367 1068.4 213.367C1106.23 213.357 1143.69 220.703 1178.64 234.983C1213.59 249.264 1245.35 270.201 1272.1 296.597C1298.85 322.994 1320.07 354.333 1334.55 388.825C1349.03 423.318 1356.48 460.287 1356.48 497.622L1356.48 814.814L780.403 814.814Z"
        fill="#D7DDEA"
      />
      <path
        d="M576.04 497.622L576.04 814.814L0 814.814L-1.24996e-05 497.622C0.00989303 422.236 30.356 349.94 84.3645 296.634C138.373 243.328 211.622 213.377 288.001 213.367C364.387 213.367 437.645 243.314 491.662 296.621C545.679 349.928 576.03 422.23 576.04 497.622Z"
        fill="#FAFAFA"
      />
      <path
        d="M988.593 814.814L988.593 612.291C988.593 564.144 1007.97 517.969 1042.46 483.925C1076.96 449.88 1123.74 430.754 1172.52 430.754C1196.68 430.749 1220.6 435.441 1242.92 444.562C1265.24 453.683 1285.52 467.054 1302.6 483.912C1319.69 500.769 1333.24 520.784 1342.48 542.811C1351.73 564.838 1356.49 588.448 1356.49 612.291L1356.49 814.814L988.593 814.814Z"
        fill="#12243A"
      />
      <path
        d="M107.515 590.322L107.515 391.561C107.515 344.315 126.531 299.003 160.379 265.595C194.228 232.186 240.137 213.418 288.006 213.418C335.875 213.418 381.784 232.186 415.632 265.595C449.481 299.003 468.497 344.315 468.497 391.561L468.497 590.322L107.515 590.322Z"
        fill="#D7DDEA"
      />
    </svg>
  );
};
